const pad = (value) => String(value).padStart(2, '0');

/**
 * `m:ss` (or `h:mm:ss` from one hour on) for a duration in milliseconds:
 * 272000 → "4:32". Negative values count as zero. Used by the countdown and by
 * the medians of the statistics, so both read the same way.
 */
export const formatDuration = (ms) => {
  const totalSeconds = Math.max(0, Math.floor(Number(ms) / 1000)) || 0;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
};

/** A number of ms, or `null` when the value is not a usable duration. */
export const durationOrNull = (value) => (typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null);

/** Epoch ms of an ISO string / Date / number, or `null`. */
export const toEpochMs = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const ms = typeof value === 'number' ? value : Date.parse(value instanceof Date ? value.toISOString() : String(value));
  return Number.isFinite(ms) ? ms : null;
};

/** Whole minutes left until `expiresAt` (rounded up, at least 1), or `null`. */
export const minutesLeft = (expiresAt, now = Date.now()) => {
  const ms = toEpochMs(expiresAt);
  if (ms === null) return null;
  return Math.max(1, Math.ceil((ms - now) / 60000));
};

/**
 * Today's date for the eyebrow over the greeting, in es-MX and lower case
 * ("martes 27 de octubre"); the style shows it in upper case. Built from the
 * parts so the locale's comma after the weekday never shows.
 */
export const formatTodayLabel = (now = Date.now()) => {
  const parts = new Intl.DateTimeFormat('es-MX', { weekday: 'long', day: 'numeric', month: 'long' })
    .formatToParts(new Date(now));
  const part = (type) => (parts.find((item) => item.type === type) || {}).value || '';
  return `${part('weekday')} ${part('day')} de ${part('month')}`.toLowerCase();
};
